module.exports = __webpack_public_path__ + "img/008.b147161e.jpg";